import { CharacterCount } from '@tiptap/extension-character-count';
import type {
   CharacterCountOptions,
   CharacterCountStorage,
} from '@tiptap/extension-character-count';

interface CustomCharacterCountOptions extends CharacterCountOptions {
   minCharacters: null | number;
}

interface CustomCharacterCountStorage extends CharacterCountStorage {
   minCharacters: null | undefined | number;
   maxCharacters: null | undefined | number;
}

export const CustomCharacterCount = CharacterCount.extend<
   CustomCharacterCountOptions,
   CustomCharacterCountStorage
>({
   addOptions() {
      return {
         ...this.parent?.(),
         minCharacters: null,
      };
   },
   addStorage() {
      return {
         ...this.parent?.(),
         minCharacters: this.options.minCharacters,
         maxCharacters: this.options.limit,
      };
   },
});
